import { Box } from '@mui/material';
import { useTranslation } from 'react-i18next';

const LayoutTooltip = ({ lang = 'ru' }) => {
  const { t } = useTranslation(['promptbar']);
  const normalizedLang = lang.toLowerCase();
  const isRussianUi = normalizedLang.startsWith('ru');

  const cyrillicColor = isRussianUi
    ? 'var(--color-text-black)'
    : 'var(--color-red-highlight)';
  const latinColor = isRussianUi
    ? 'var(--color-red-highlight)'
    : 'var(--color-text-black)';

  return (
    <Box display="flex" gap={1}>
      <span style={{ color: cyrillicColor }}>{t('promptbar:cyrillic')}</span>
      <span style={{ color: latinColor }}>{t('promptbar:latin')}</span>
    </Box>
  );
};

export default LayoutTooltip;
